import { useState, useEffect, useContext } from 'react';
import { AppBar, Toolbar, IconButton, Box } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import styled from 'styled-components';
import { NavLink, useNavigate } from 'react-router-dom';

import { AuthContext } from '../../contextAPI/ContextAPI';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import backArrow from '../../../assets/common/back-arrow.svg';
import styles from './CustomHeader.module.css';

const isMobile = window.innerWidth < 900;

const icon = {
  cursor: 'pointer',
  color: '#79b835',
  margin: '4px',
  fontSize: '26px',
};

const btnContainer = {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
};

const btnContainerNoFlex = {
  width: '100%',
};

const flexContainer = {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
};

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
`;

const container = { backgroundColor: '#F6F6F6', height: '62px' };

const CustomHeader = ({ name }) => {
  const { auth } = useContext(AuthContext);
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(
    isMobile ? false : JSON.parse(localStorage.getItem('isDrawerOpen'))
  );

  useEffect(() => {
    localStorage.setItem('isDrawerOpen', drawerOpen);
  }, [drawerOpen]);

  useEffect(() => {
    let storedUser;
    try {
      storedUser = JSON.parse(
        window.localStorage.getItem(LOCAL_STORAGE_KEYS.STORED_USER_DATA)
      );
      setUser(storedUser);
    } catch (error) {
      console.error(error);
    }
  }, []);

  const onClickLogout = async () => {
    try {
      const res = await window.Platform.database.logOut();

      if (!res?.hasError) {
        localStorage.clear();
        window.location.reload();
      }
      auth.onAuthUserChanged && auth.onAuthUserChanged();
    } catch (error) {
      window.NotificationUtils.showError('Something Went Wrong');
    }
  };

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  return (
    <AppBar position='sticky' sx={container}>
      <Toolbar>
        <div style={flexContainer}>
          {isMobile && (
            <IconButton onClick={toggleDrawer}>
              <MenuIcon />
            </IconButton>
          )}
          <div
            style={
              name === 'expense' ||
              name === 'target-achievement' ||
              name === 'assigned-target-achievement' ||
              name === 'distributor-mapping' ||
              name === 'distributor-overview' ||
              name === 'financial-report'
                ? btnContainer
                : btnContainerNoFlex
            }
          >
            {name === 'distributor-mapping' && (
              <FlexContainer>
                <img
                  className={styles.backArrow}
                  src={backArrow}
                  onClick={() => navigate('/activity-dashboard')}
                />
                <NavLink
                  to='/distributor-mapping'
                  className={({ isActive, isPending }) =>
                    isActive ? `${styles.active}` : `${styles.pending}`
                  }
                >
                  Distributor Mapping
                </NavLink>
              </FlexContainer>
            )}

            {name === 'financial-report' && (
              <FlexContainer>
                <img
                  className={styles.backArrow}
                  src={backArrow}
                  onClick={() => navigate('/activity-dashboard')}
                />
                <NavLink
                  to='/financialreport'
                  className={({ isActive, isPending }) =>
                    isActive ? `${styles.active}` : `${styles.pending}`
                  }
                >
                  Financial Report
                </NavLink>
              </FlexContainer>
            )}

            {name === 'distributor-overview' && (
              <FlexContainer>
                <img
                  className={styles.backArrow}
                  src={backArrow}
                  onClick={() => navigate(-1)}
                />
                <NavLink
                  to='/distributor-overview'
                  className={({ isActive, isPending }) =>
                    isActive ? `${styles.active}` : `${styles.pending}`
                  }
                >
                  Distributor Overview
                </NavLink>
              </FlexContainer>
            )}

            {name === 'expense' && (
              <FlexContainer>
                <img
                  className={styles.backArrow}
                  src={backArrow}
                  onClick={() => navigate('/activity-dashboard')}
                />
                {/* <NavLink
                  to='/draft-expense'
                  className={({ isActive, isPending }) =>
                    isActive ? `${styles.active}` : `${styles.pending}`
                  }
                >
                  Draft
                </NavLink>
                <NavLink
                  to='/claim-expense'
                  className={({ isActive, isPending }) =>
                    isActive ? `${styles.active}` : `${styles.pending}`
                  }
                >
                  Claim
                </NavLink> */}

                <NavLink
                  to='/approval-pending-expense'
                  className={({ isActive, isPending }) =>
                    isActive ? `${styles.active}` : `${styles.pending}`
                  }
                >
                  {user?.profile__c === 'Finance'
                    ? 'Expense Records'
                    : 'Pending Approval'}
                </NavLink>

                {user?.profile__c !== 'Finance' && (
                  <NavLink
                    to='/history-expense'
                    className={({ isActive, isPending }) =>
                      isActive ? `${styles.active}` : `${styles.pending}`
                    }
                  >
                    Expense History
                  </NavLink>
                )}
              </FlexContainer>
            )}
            {name === 'target-achievement' && (
              <FlexContainer>
                <img
                  className={styles.backArrow}
                  src={backArrow}
                  onClick={() => navigate('/activity-dashboard')}
                />
                <NavLink
                  to='/view-target-achievement'
                  className={({ isActive, isPending }) =>
                    isActive ? `${styles.active}` : `${styles.pending}`
                  }
                >
                  View My Targets
                </NavLink>
                <NavLink
                  to='/assign-target-achievement'
                  className={({ isActive, isPending }) =>
                    isActive ? `${styles.active}` : `${styles.pending}`
                  }
                >
                  Assign Team Targets
                </NavLink>
              </FlexContainer>
            )}
            {name === 'assigned-target-achievement' && (
              <FlexContainer>
                <img
                  className={styles.backArrow}
                  src={backArrow}
                  onClick={() => navigate('/activity-dashboard')}
                />
                <NavLink
                  to='/assigned-target-achievement'
                  className={`${styles.active}`}
                >
                  Assigned Target & Achievement
                </NavLink>
              </FlexContainer>
            )}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
                float:
                  name === 'expense' || name === 'target-achievement'
                    ? 'unset'
                    : 'right',
                transition: '0.7s all',
                '&:hover': {
                  cursor: 'pointer',
                  transform: 'scale(1.1)',
                },
              }}
              onClick={onClickLogout}
              title='Log Out'
            >
              <LogoutOutlinedIcon sx={icon} />
              <span style={{ color: '#000' }}>(Log Out)</span>
            </Box>
          </div>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default CustomHeader;
